import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class archiveItemComponent extends Component {
  @service router;
  @service store;

  @action
  restoreItem(item) {
    item.archived = false;
    if (this.router.currentURL.includes('teams')) {
      item.team = this.store.peekRecord('team', this.args.parent_id);
    } else if (this.router.currentURL.includes('initiatives')) {
      item.initiative = this.store.peekRecord(
        'initiative',
        this.args.parent_id,
      );
    }

    item.save();
  }
  get showTeamsBadge() {
    return this.args?.badges?.includes('teams') ?? false;
  }

  get showDelayBadge() {
    return this.args?.badges?.includes('delay') ?? false;
  }

  get showInitiativesBadge() {
    return this.args?.badges?.includes('initiatives') ?? false;
  }

  get showWorkstreamsBadge() {
    return this.args?.badges?.includes('workstreams') ?? false;
  }

  get showWeeksBadge() {
    return this.args?.badges?.includes('weeks') ?? false;
  }

  @action
  toggleCompleted() {
    this.args.item.completed = !this.args.item.completed;
  }
}
